
import BillingSelection from "./BillingSelection";

interface BillingOptionsProps {
  billingOption: "monthly" | "yearly";
  setBillingOption: (option: "monthly" | "yearly") => void;
}

const BillingOptions = ({ billingOption, setBillingOption }: BillingOptionsProps) => {
  return (
    <div className="space-y-8">
      <BillingSelection 
        billingOption={billingOption}
        setBillingOption={setBillingOption}
      />
    </div>
  );
};

export default BillingOptions;
